import { ca } from '@cian/analytics';

import { getTrackingProducts } from '../../utils/tracking';

export const trackClickProjectCard = (builderId: number, projectId: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardCountryBuilder',
    action: 'Click',
    label: 'HouseProjects',
    products: getTrackingProducts(builderId, { house_id: projectId }),
  });
};

export const trackShowMoreProjects = (builderId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardCountryBuilder',
    action: 'Click_sopr',
    label: 'HouseProjectsMore',
    products: getTrackingProducts(builderId),
  });
};
